import { render } from "./FirstSidebarLink.vue?vue&type=template&id=3c456532&scoped=true"
import script from "./FirstSidebarLink.vue?vue&type=script&lang=js"
export * from "./FirstSidebarLink.vue?vue&type=script&lang=js"

import "./FirstSidebarLink.vue?vue&type=style&index=0&id=3c456532&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c456532"]])

export default __exports__